import { useState, useEffect } from 'react';

const ChristmasPopup = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if we should show the popup
        const now = new Date();
        const endDate = new Date('2026-01-02T00:00:00+01:00'); // 1 Januar midnight (start of 2nd)

        // Show popup only if current date is before Jan 2, 2026
        if (now < endDate) {
            setIsVisible(true);
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                onClick={handleClose}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 9998,
                    backdropFilter: 'blur(4px)',
                }}
            />

            {/* Popup */}
            <div
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#fff',
                    borderRadius: '16px',
                    padding: '32px',
                    zIndex: 9999,
                    maxWidth: '90%',
                    width: '400px',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    textAlign: 'center',
                    animation: 'popupFadeIn 0.3s ease-out',
                }}
            >
                {/* Close button */}
                <button
                    onClick={handleClose}
                    style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#666',
                        padding: '4px 8px',
                        lineHeight: 1,
                    }}
                    aria-label="Schließen"
                >
                    ×
                </button>

                {/* Holiday icon */}
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎄🎆</div>

                {/* Title */}
                <h2
                    style={{
                        margin: '0 0 20px 0',
                        fontSize: '24px',
                        fontWeight: '700',
                        color: '#1a1a1a',
                    }}
                >
                    Weihnachten & Neujahr Öffnungszeiten
                </h2>

                {/* Opening hours */}
                <div
                    style={{
                        backgroundColor: '#f8f9fa',
                        borderRadius: '12px',
                        padding: '20px',
                        marginBottom: '20px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 0',
                            borderBottom: '1px solid #e9ecef',
                        }}
                    >
                        <span style={{ fontWeight: '600', color: '#333' }}>24. Dezember</span>
                        <span style={{ color: '#28a745', fontWeight: '500' }}>bis 17.00 Uhr</span>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 0',
                            borderBottom: '1px solid #e9ecef',
                        }}
                    >
                        <span style={{ fontWeight: '600', color: '#333' }}>25. Dezember</span>
                        <span style={{ color: '#dc3545', fontWeight: '500' }}>geschlossen</span>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 0',
                        }}
                    >
                        <span style={{ fontWeight: '600', color: '#333' }}>1. Januar</span>
                        <span style={{ color: '#dc3545', fontWeight: '500' }}>geschlossen</span>
                    </div>
                </div>

                {/* Footer message */}
                <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                    Frohe Weihnachten und ein gutes neues Jahr! 🎅🎉
                </p>
            </div>

            {/* Animation keyframes */}
            <style>
                {`
          @keyframes popupFadeIn {
            from {
              opacity: 0;
              transform: translate(-50%, -50%) scale(0.9);
            }
            to {
              opacity: 1;
              transform: translate(-50%, -50%) scale(1);
            }
          }
        `}
            </style>
        </>
    );
};

export default ChristmasPopup;
